import { combineReducers } from 'redux'
import addItemReducer from '../Reducers/AddItemReducer'

export const rootReducer = combineReducers({
    addItemReducer: addItemReducer,
})